import { render, staticRenderFns } from "./CampaignResult.vue?vue&type=template&id=56edae4c&scoped=true&"
import script from "./CampaignResult.vue?vue&type=script&lang=js&"
export * from "./CampaignResult.vue?vue&type=script&lang=js&"
import style0 from "./CampaignResult.vue?vue&type=style&index=0&id=56edae4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edae4c",
  null
  
)

export default component.exports